import React from "react";
import { getDiaStrTurno } from "global/utils/diasTurno";
import "./CardTurnoFiltro.css";
import {
  CardBody,
  CardContainer,
  CardTitle,
  ConfirmarBtn,
  DiaContainer,
  DiaTexto,
} from "./localstyle";
import { getLocalStorage } from "global/utils/safeJsonParse";

const CardTurnoFiltro2 = ({
  idTurno,
  medico,
  centro,
  ubicacion,
  coordenadaGps,
  hora,
  fecha,
  handleOnClickConfirmar,
  especialidad,
  proceso,
}) => {
  const idTerminal = getLocalStorage("idTerminal");

  return (
    <CardContainer>
      <CardTitle className="c-white rb16m">
        {proceso === "labo" ? centro : medico}
      </CardTitle>
      <CardBody $proceso={proceso}>
        <p>{especialidad}</p>
        {proceso !== "labo" && <p className="rb16xl">{centro}</p>}
        <a
          href={!idTerminal && `https://maps.google.com/?q=${coordenadaGps}`}
          target="_blank"
          rel="noreferrer"
          className="c-latex30 rb12tl"
        >
          {ubicacion}
        </a>
        <DiaContainer>
          <DiaTexto className="rb16xl">
            <div>
              {getDiaStrTurno(fecha, false, true)}
              {getDiaStrTurno(fecha, true, true)}
            </div>
            <span className="rb16t">{`${hora}hs`}</span>
          </DiaTexto>
          <div>
            <ConfirmarBtn
              id={idTurno}
              onClick={() => handleOnClickConfirmar()}
              className="c-primary rb18m"
            >
              Confirmar
            </ConfirmarBtn>
          </div>
        </DiaContainer>
      </CardBody>
    </CardContainer>
  );
};
export default React.memo(CardTurnoFiltro2, (prev, next) => {
  return (
    prev.idTurno === next.idTurno &&
    prev.medico === next.medico &&
    prev.centro === next.centro &&
    prev.ubicacion === next.ubicacion &&
    prev.coordenadaGps === next.coordenadaGps &&
    prev.hora === next.hora &&
    prev.fecha === next.fecha &&
    prev.especialidad === next.especialidad &&
    prev.proceso === next.proceso
  );
});
